// src/pages/Login.js (SIMPLIFIÉ - Contient UNIQUEMENT le formulaire)
import React, { useState } from 'react';
// Link n'est plus nécessaire ici car la navigation se fait dans Layout
import { useTranslation } from 'react-i18next';
// Nous allons réutiliser les styles pour le formulaire
import './Login.css'; 

// Icônes SVG (conservées pour le style du formulaire)
const IconEnvelope = (props) => (
    <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" {...props}>
        <path d="M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM464 256.4L267.7 416H48V112l219.7 155.6c4.6 3.3 11.4 3.3 16 0L464 112V256.4z"/>
    </svg>
);

const IconLock = (props) => (
    <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" {...props}>
        <path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM224 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-17.7-14.3-32-32-32zm64-112v48H368c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h80v-48c0-70.7 57.3-128 128-128s128 57.3 128 128V144z"/>
    </svg>
);

function Login() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const tOrDefault = (key, defaultValue) => t(key) || defaultValue;

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');
    setIsLoading(true);

    if (!email || !password) {
      setErrorMsg(tOrDefault('error_required', 'Veuillez remplir tous les champs.'));
      setIsLoading(false);
      return;
    }

    // SIMULATION D'APPEL API
    setTimeout(() => {
        if (email === 'test@belfich.com' && password === 'password') {
            setSuccessMsg(tOrDefault('success_message', 'Connexion réussie ! Redirection...'));
        } else {
            setErrorMsg(tOrDefault('error_credentials', 'Email ou mot de passe incorrect.'));
        }
        setIsLoading(false);
    }, 1500);
  };

  return (
    // Utilisez une classe ou un style pour centrer le formulaire Login
    <div className="login-page-content"> 
      <div className="login-container">
        <h2 className="login-title">
            {tOrDefault('login_title', 'Se Connecter')}
        </h2>
        
        <form className="login-form" onSubmit={handleSubmit}>
          
            {/* Champ Email */}
            <div className="input-group">
                <IconEnvelope />
                <label htmlFor="email" className="sr-only">Adresse e-mail</label>
                <input
                    type="email"
                    id="email"
                    placeholder={tOrDefault('email_placeholder', 'Adresse e-mail')}
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                />
            </div>

            {/* Champ Mot de passe */}
            <div className="input-group">
                <IconLock />
                <label htmlFor="password" className="sr-only">Mot de passe</label>
                <input
                    type="password"
                    id="password"
                    placeholder={tOrDefault('password_placeholder', 'Mot de passe')}
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                />
            </div>

            {/* Messages de statut */}
            {errorMsg && <p className="error-message visible">{errorMsg}</p>}
            {successMsg && <p className="success-message visible">{successMsg}</p>}

            {/* Bouton de soumission */}
            <button type="submit" className="login-btn" disabled={isLoading}>
                {isLoading ? tOrDefault('btn_connecting', 'Connexion...') : tOrDefault('btn_submit', 'Se Connecter')}
            </button>
        </form>

        {/* Lien mot de passe oublié */}
        <p className="forgot-password-link">
            <a href="#">{tOrDefault('link_forgot', 'Mot de passe oublié ?')}</a>
        </p>
      </div>
    </div>
  );
}

export default Login;